<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005f32"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showsnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-start pa-2 pa-md-4>
      <v-flex xs12>
        <v-card class="elevation-2 rounded-lg overflow-hidden">
          <v-data-table
            :headers="headers"
            :items="fakeGpsList"
            :loading="appLoading"
            class="elevation-0 custom-table"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:top>
              <v-toolbar flat color="white" class="px-2 pt-2">
                <v-spacer></v-spacer>
                <v-flex xs12 sm6 md4 lg3>
                  <v-text-field
                    color="#005f32"
                    class="rounded-xl"
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    dense
                    hide-details
                    label="Search Employees..."
                    v-model="searchKeyword"
                    clearable
                    @input="onSearch"
                  ></v-text-field>
                </v-flex>
              </v-toolbar>
            </template>
                <!-- Status Column -->
                <template v-slot:item.status="{ item }">
                  <span class="text-capitalize" :style="{ color: item.status === 'login' ? '#005f32' : '#d32f2f' }">{{ item.status }}</span>
                </template>
                <template v-slot:no-data>
                  <div class="pa-16 kumbhRegular text-center">No Data found!</div>
                </template>
              </v-data-table>
            </v-card>

            <v-layout wrap justify-center pt-3 v-if="pagelength > 0">
          <v-flex xs12 text-center>
            <v-pagination
              v-model="page"
              :length="pagelength"
              color="#005f32"
            ></v-pagination>
          </v-flex>
        </v-layout>
          </v-flex>
        </v-layout>
    </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      showsnackbar: false,
      msg: null,
      searchKeyword: null,
      searchTimeout: null,
      appLoading: false,
      page: 1,
      pagelength: 0,
      dataLimit: 10,
      headers: [
        { text: "Employee Name", value: "employeeName", sortable: false, class: "white--text" },
        { text: "Mock Punches", value: "mockPunches", sortable: false, class: "white--text" },
        { text: "Date & Time", value: "date", sortable: false, class: "white--text" },
        { text: "Location", value: "location", sortable: false, class: "white--text" },
        { text: "Punch Type", value: "status", sortable: false, class: "white--text" },
      ],
      fakeGpsList: [],
    };
  },
  watch: {
    page() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    onSearch() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        if (this.page !== 1) {
          this.page = 1; // changing page triggers getData automatically via watch
        } else {
          this.getData();
        }
      }, 500);
    },
    getData() {
      this.appLoading = true;
      axios.post('/fake-gps/list', {
        page: this.page,
        limit: this.dataLimit,
        attendanceType: 'both',
        search: this.searchKeyword
      }, {
        headers: { 'x-auth-token': localStorage.getItem("token") }
      })
      .then(res => {
         this.appLoading = false;
         if (res.data && res.data.status) {
             this.fakeGpsList = res.data.data.map(item => {
                 let d = new Date(item.attendanceTime);
                 let dateStr = d.toLocaleDateString() + ' ' + d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                 
                 return {
                   employeeName: item.uid && item.uid.name ? item.uid.name : 'Unknown',
                   mockPunches: item.employeeMockPunchInCount || 0,
                   date: dateStr,
                   location: item.address || (item.location ? item.location.join(', ') : 'N/A'),
                   status: item.attendanceType,
                 };
             });
             this.pagelength = Math.ceil((res.data.length || 0) / (res.data.limit || this.dataLimit));
         } else {
             this.msg = res.data.msg || "Failed to fetch data";
             this.showsnackbar = true;
             this.pagelength = 0;
             this.fakeGpsList = [];
         }
      })
      .catch(err => {
         this.appLoading = false;
         this.msg = "Server Error";
         this.showsnackbar = true;
         this.pagelength = 0;
         this.fakeGpsList = [];
         console.error(err);
      });
    },
  },
};
</script>

<style scoped>
.kumbhRegular {
  font-family: 'KumbhRegular';
}
.custom-table >>> thead {
  background-color: #005f32 !important;
}
.custom-table >>> th {
  font-family: "kumbhMedium" !important;
  font-size: 15px !important;
  color: #ffffff !important;
}
.custom-table >>> td {
  font-family: "kumbhMedium" !important;
  font-size: 14px !important;
}


</style>
